import { createSlice } from "@reduxjs/toolkit";
import { SubjectResponseDto } from "../../shared/dtos/subject/SubjectResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const subjectSlice = createSlice({
  name: "subject",
  initialState: getInitialCrudState<SubjectResponseDto>(),
  reducers: {
    ...generateCrudReducers<SubjectResponseDto>(),
  },
});

export const subjectActions = subjectSlice.actions;
export default subjectSlice.reducer;
